module.exports = __webpack_public_path__ + "media/images/countrysquared/gu-16cd4206b0d812d22732663cdcdef0e1.svg";